module.exports = __webpack_public_path__ + "img/access-denied.95119323.png";